// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__mwzzg","footer":"Form_footer__1il4H"};